import { FIELD_TYPES } from '../../../components/FormField'

export const FIELDS = [
  { label: 'Name', name: 'name', type: FIELD_TYPES.TEXT, defaultValue: '' },
  {
    label: 'Type',
    name: 'typeId',
    type: FIELD_TYPES.SIGEVENTS_INCIDENT_TYPE,
    defaultValue: '',
  },
  {
    label: 'Status',
    name: 'status',
    type: FIELD_TYPES.SELECT,
    defaultValue: 0,
    options: [
      { label: 'Active', value: 0 },
      { label: 'Closed', value: 1 },
    ],
  },
]
